import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box } from '@material-ui/core';
import { PasslyButton } from '@app/components';
import { sortAppsByLaunchTime, sortAppsByName, getAppsLoading } from '@app/store/actions/launchpad.actions';
import { useTypedTranslation } from '../../hooks';
import { AccessTime, SortByAlpha } from '@material-ui/icons';
import { Order, OrderType } from '@app/models';
import { PasslyTooltip } from '@app/componentsV2';

export const LaunchpadSortingComponent: React.SFC = () => {
    const apps = useSelector((state: any) => state.launchPad.apps);
    const timeSort = 'time';
    const nameSort = 'name';

    const [selectedSort, setSelectedSort] = useState(timeSort);
    const [timeSortDirection, setTimeSortDirection] = useState(Order.desc);
    const [nameSortDirection, setNameSortDirection] = useState(Order.asc);

    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const sortTime = (order: OrderType) => {
        dispatch(sortAppsByLaunchTime(apps, order, dispatch));
        setTimeSortDirection(order);
    }

    const handleSortByTime = () => {
        dispatch(getAppsLoading(true));

        if (selectedSort === timeSort) {
            if (timeSortDirection === Order.desc) {
                sortTime(Order.asc);
            }
            else {
                sortTime(Order.desc);
            }
            
        } else {
            sortTime(Order.desc);
        }

        setSelectedSort(timeSort);
    }

    const sortName = (order: OrderType) => {
        dispatch(sortAppsByName(apps, order, dispatch));
        setNameSortDirection(order);
    }

    const handleSortByName = () => {
        dispatch(getAppsLoading(true));

        if (selectedSort === nameSort) {
            if (nameSortDirection === Order.desc) {
                sortName(Order.asc);
            }
            else {
                sortName(Order.desc);
            }

        } else {
            sortName(Order.asc);
        }

        setSelectedSort(nameSort);
    }

    return (
        <>
            <PasslyTooltip title={translation('SORT_BY_LAST_ACCESSED')}>
                <Box mr={1}>
                    <PasslyButton id='sortByTimeButton' onClick={handleSortByTime}>
                        <AccessTime color='primary' />
                    </PasslyButton>
                </Box>
            </PasslyTooltip>
            <PasslyTooltip title={translation('SORT_BY_NAME')}>
                <div>
                    <PasslyButton id='sortByNameButton' onClick={handleSortByName}>
                        <SortByAlpha color='primary' />
                    </PasslyButton>
                </div>
            </PasslyTooltip>
        </>

    );
};
